import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { imageUrl } from "../../lib/format";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Switch } from "../../components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

export default function AdminInventory() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");

  const load = () => {
    const params = filter !== "all" ? { disponibilite: filter } : {};
    api.get("/admin/inventory", { params }).then((r) => setProducts(r.data));
  };
  useEffect(() => { load(); }, [filter]);

  const toggle = async (p) => {
    const next = p.disponibilite === "Rupture" ? "En stock" : "Rupture";
    await api.put(`/admin/products/${p.id}/disponibilite`, { disponibilite: next });
    toast.success(`« ${p.nom} » → ${next}`);
    load();
  };

  const visible = products.filter((p) => p.nom.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <h1 className="mb-6 font-serif text-3xl font-medium text-[#2C1A14]">Inventaire</h1>
      <p className="mb-4 text-sm text-[#6E544A]">Chaque produit est une pièce unique. Basculez la disponibilité selon vos ventes.</p>

      <div className="mb-4 flex flex-wrap gap-3">
        <Input placeholder="Rechercher..." value={search} onChange={(e) => setSearch(e.target.value)} data-testid="inventory-search" className="max-w-xs bg-white" />
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger data-testid="inventory-filter" className="w-48 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Toutes disponibilités</SelectItem>
            <SelectItem value="En stock">En stock</SelectItem>
            <SelectItem value="Rupture">Rupture</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-3">
        {visible.map((p) => {
          const rupture = p.disponibilite === "Rupture";
          return (
            <div key={p.id} data-testid={`inventory-${p.id}`} className="flex items-center gap-4 rounded-xl bg-white p-4 ring-1 ring-[#E8D5CE]">
              <img src={imageUrl(p.images?.[0], 320)} alt="" className="h-16 w-14 rounded object-cover" />
              <div className="flex-1">
                <h3 className="font-serif text-lg text-[#2C1A14]">{p.nom}</h3>
                <p className="text-xs text-[#9B7E73]">{p.taille ? `Taille ${p.taille} · ` : ""}{p.type}</p>
              </div>
              <span className={`rounded-full px-3 py-1 text-xs font-semibold ${rupture ? "bg-red-100 text-red-600" : "bg-green-100 text-green-700"}`}>
                {p.disponibilite}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-xs text-[#9B7E73]">En stock</span>
                <Switch checked={!rupture} onCheckedChange={() => toggle(p)} data-testid={`dispo-switch-${p.id}`} />
              </div>
            </div>
          );
        })}
        {visible.length === 0 && <p className="py-10 text-center text-[#9B7E73]">Aucun produit</p>}
      </div>
    </div>
  );
}
